import Mux from '@mux/mux-node';
import { server } from '../config';

let video;

export function initializeMux() {
  if (!video) {
    video = new Mux(server.MUX_TOKEN_ID, server.MUX_TOKEN_SECRET);
  }
  return video;
}
